import React, { useState } from "react";
import axios from "axios";

// Internet Archive ingest panel — mirrors YouTubeIngest. Accepts either a
// full archive.org/details/{id} URL or a bare item identifier; backend does
// the resilient parsing.
export default function ArchiveIngest({
  apiBase,
  authHeaders,
  channels,
  selectedChannel,
  busy,
  setBusy,
  append,
  onUploaded,
  onTuneToChannel,
}) {
  const [iaUrl, setIaUrl] = useState("");
  const [iaTitle, setIaTitle] = useState("");

  const handleAddArchive = async () => {
    if (!selectedChannel || !iaUrl.trim()) {
      append("> ERROR: SELECT A CHANNEL AND PASTE AN ARCHIVE.ORG URL");
      return;
    }
    setBusy(true);
    // Sub-channels are derived — proxy ingest to the parent DB row.
    const selectedCh = channels.find((c) => c.id === selectedChannel);
    const isSubChannel = !!selectedCh?.isSubChannel;
    const effectiveChannelId = isSubChannel ? selectedCh.parent_id : selectedChannel;
    append(`> LINKING ARCHIVE.ORG TAPE TO CH ${channels.find((c) => c.id === effectiveChannelId)?.number}...`);
    try {
      await axios.post(
        `${apiBase}/channels/${effectiveChannelId}/archive`,
        { url: iaUrl.trim(), title: iaTitle.trim() || null },
        { headers: { "Content-Type": "application/json", ...authHeaders() } }
      );
      append("> ARCHIVE.ORG TAPE LINKED.");
      setIaUrl("");
      setIaTitle("");
      await onUploaded(effectiveChannelId);
      if (onTuneToChannel) onTuneToChannel(effectiveChannelId);
    } catch (e) {
      append(`> ERROR: ${e.response?.data?.detail || e.message}`);
    } finally {
      setBusy(false);
    }
  };

  const _selectedCh = channels.find((c) => c.id === selectedChannel);
  const _effectiveId = _selectedCh?.isSubChannel ? _selectedCh.parent_id : selectedChannel;
  const chLabel = channels.find((c) => c.id === _effectiveId)?.number ?? "?";

  return (
    <div className="border border-[color-mix(in_srgb,var(--phosphor)_40%,transparent)] p-2" data-testid="archive-panel">
      <div className="text-[11px] opacity-80 mb-1">&gt; LINK AN INTERNET ARCHIVE TAPE (NO UPLOAD):</div>
      <div className="flex flex-col gap-1.5">
        <input
          type="text"
          value={iaUrl}
          onChange={(e) => setIaUrl(e.target.value)}
          placeholder="https://archive.org/details/... or item id"
          data-testid="archive-url-input"
          className="w-full bg-black border border-[var(--phosphor)] text-[var(--phosphor)] p-1.5 text-[11px] outline-none placeholder:text-[color-mix(in_srgb,var(--phosphor)_40%,transparent)]"
        />
        <input
          type="text"
          value={iaTitle}
          onChange={(e) => setIaTitle(e.target.value)}
          placeholder="Display title (optional)"
          data-testid="archive-title-input"
          className="w-full bg-black border border-[var(--phosphor)] text-[var(--phosphor)] p-1.5 text-[11px] outline-none placeholder:text-[color-mix(in_srgb,var(--phosphor)_40%,transparent)]"
        />
        <button
          onClick={handleAddArchive}
          disabled={busy || !iaUrl.trim() || !selectedChannel}
          data-testid="archive-add-button"
          className="border border-[var(--phosphor)] py-1 text-[11px] hover:bg-[var(--phosphor)] hover:text-black transition-colors disabled:opacity-40 disabled:cursor-not-allowed font-bold tracking-widest"
        >
          LINK TAPE TO CH {chLabel}
        </button>
        <div className="text-[9px] opacity-60">
          archive.org tapes play through their embed (no upload, no watermark, no auto-advance).
        </div>
      </div>
    </div>
  );
}
